/**
 * Index route — redirects to Ask Argus (the primary chat experience)
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const hasAccessToken =
      typeof window !== 'undefined' && !!localStorage.getItem('accessToken');

    throw redirect({
      to: hasAccessToken ? '/ask-argus' : '/login',
      replace: true,
    });
  },
  component: EmptyIndexRoute,
});

function EmptyIndexRoute() {
  return null;
}
